<template>
  <div>
    <b-navbar toggleable="lg" type="dark">
      <b-navbar-brand href="#"></b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav align="center">
        <b-navbar-nav>
          <b-nav-item href="#" v-scroll-to="'#firstPage'">首頁</b-nav-item>
          <b-nav-item href="https://youtu.be/_1GCVfLjg0Q" target="_blank"
            >線上直播</b-nav-item
          >
          <b-nav-item href="#" v-scroll-to="'#secondPage'"
            >研討會介紹</b-nav-item
          >
          <b-nav-item href="#" v-scroll-to="'#thirdPage'">議程表</b-nav-item>
          <b-nav-item href="#" v-scroll-to="'#fourthPage'"
            >報名研討會</b-nav-item
          >
          <b-nav-item href="#" v-scroll-to="'#sixthPage'">交通指南</b-nav-item>
          <b-nav-item href="https://portal-3dgdp.colife.org.tw" target="_blank"
            >精彩成果</b-nav-item
          >
          <b-nav-item
            href="https://drive.google.com/drive/folders/1LWoWq17uXGAb3Z-yWDAjpPuOaBTtyU0E?usp=sharing"
            target="_blank"
            >研討會簡報</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div id="wrapper">
      <div id="firstPage" class="section home">
        <div class="container">
          <div class="row">
            <div class="col-lg-7 align-self-center">
              <h1 class="main-title-group">
                <div class="main-title" data-aos="fade-up">
                  <div class="main-title-text">
                    2022 <br />
                    三維空間資訊基礎環境共構及資料聯盟應用研討會
                  </div>
                </div>
                <div
                  class="main-title-date pl-5"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  2022年10月19日 13:00-17:00
                </div>
                <div
                  class="main-title-time pl-5"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  犇亞會議中心 CDE會議室<br />(台北市松山區復興北路99號15樓)
                </div>
                <div class="pl-5">
                  <!-- <a class="btn mr-3" href="#" v-scroll-to="'#fourthPage'"><span
                      class="icon icon-arrow-right mr-1"></span>報名研討會</a> -->

                  <a
                    class="btn"
                    href="https://youtu.be/_1GCVfLjg0Q"
                    target="b_blank"
                    ><span class="icon icon-arrow-right mr-1"></span>線上直播</a
                  >
                </div>
              </h1>
            </div>
            <div class="col-lg-5 align-self-center">
              <img
                src="imgs/main_img.png"
                class="img-fluid"
                alt=""
                data-aos="fade-left"
                data-aos-delay="200"
              />
            </div>
          </div>
        </div>
      </div>

      <div id="secondPage" class="section forum-info">
        <div class="container">
          <h2>研討會介紹</h2>
          <div class="row">
            <div class="col-lg-6">
              <p>
                財團法人國家實驗研究院國家高速網路與計算中心（以下簡稱國網中心）以全國性骨幹網路及高速運算環境為基礎，結合既有研發能量與大型主機建置營運經驗，打造基於三維空間的資訊基礎環境共構，並持續導入資料立方(DataCube)技術，耕耘空間資料聯盟系統，期能以雲端快速佈署、鏈結空間數據，發揮公部門數位孿生與跨域數據治理之綜效。
              </p>
              <p>
                為展示雲端共構及資料聯盟整合成果等技術分享，國網中心於民國111年10月19日（星期三）辦理「2022三維空間資訊基礎環境共構及資料聯盟應用研討會」，誠摯邀請各界產官學研先進共同與會交流。議程將規劃「三維共構應用」、「資料聯盟應用」兩大類主題，邀請國內外政府、企業單位等專家學者共同參與，進而展現國網中心推動三維空間資訊服務，達成強化公部門多維度圖台應用、降低軟體採購成本與單位資源整合推動之目標。
              </p>
            </div>
            <div class="col-lg-6">
              <img
                src="imgs/info_img.png"
                class="img-fluid"
                alt=""
                data-aos="fade-left"
                data-aos-delay="200"
              />
              <!-- <a href="http://rasai.colife.org.tw/LandingPage/" target="_blank">
                <img src="imgs/info_link_img.jpg" class="img-fluid pt-3" alt="" data-aos="fade-left"
                  data-aos-delay="200" />
              </a> -->
            </div>
          </div>
        </div>
      </div>

      <div id="thirdPage" class="section forum-schedule">
        <div class="container">
          <h2 style="display: inline-block">議程表</h2>
          <!-- <h3 style="display: inline-block; color: white" class="ml-5">
            ※線上直播觀看無人數限制
          </h3> -->
          <a
            class="btn float-right"
            href="https://ezsign.gis.tw/nchc2022event/file/2022%E4%B8%89%E7%B6%AD%E7%A9%BA%E9%96%93%E8%B3%87%E8%A8%8A%E5%9F%BA%E7%A4%8E%E7%92%B0%E5%A2%83%E5%85%B1%E6%A7%8B%E5%8F%8A%E8%B3%87%E6%96%99%E8%81%AF%E7%9B%9F%E6%87%89%E7%94%A8%E7%A0%94%E8%A8%8E%E6%9C%83%E8%AD%B0%E7%A8%8B%E8%A1%A8.pdf"
            target="_blank"
            ><span class="icon icon-download2 mr-1"></span>議程表下載</a
          >
          <div class="clearfix"></div>

          <div class="agenda-timeline">
            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">12:45</div>
              <div class="agenda-timeline-content">報到</div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">13:00</div>
              <div class="agenda-timeline-content">
                開幕 / 長官貴賓致詞 / 大合照
              </div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">13:10</div>
              <div class="agenda-timeline-content">
                國網中心空間資訊基礎環境共構
                <small class="d-block"
                  >財團法人國家實驗研究院國家高速網路與計算中心 施奕良
                  副研究員</small
                >
              </div>

              <!-- <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  海空三維資訊平台應用於災害救援情資整合
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span>逢甲大學地理資訊系統研究中心 郝振宇副處長
                </div>
              </div> -->
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">13:30</div>
              <div class="agenda-timeline-content">交誼時間(Tea Break)</div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">13:35</div>
              <div class="agenda-timeline-content">
                主題一：三維共構應用
                <small class="d-block"
                  >主持人：財團法人國家實驗研究院國家高速網路與計算中心 施奕良
                  副研究員</small
                >
              </div>
              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  三維地下管線系統應用與展示
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span>臺南市工務局 簡國棟
                  正工程司
                </div>
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  全方位地理資訊系統應用與展示
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span>基隆市地政處 蘇昱彰
                  處長
                </div>
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  圖資雲端整合服務應用與展示
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span>南投縣政府計畫處
                  謝祥裕 科長
                </div>
              </div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">15:00</div>
              <div class="agenda-timeline-content">交誼時間(Tea Break)</div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">15:20</div>
              <div class="agenda-timeline-content">
                主題二：資料聯盟應用
                <small class="d-block"
                  >主持人：逢甲大學地理資訊系統研究中心 周天穎 主任</small
                >
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  整合資料同盟多時序福衛影像進行崩塌地判釋應用
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span
                  >財團法人國家實驗研究院國家太空中心 張立雨 正工程師
                </div>
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  BigGIS發展現況與空間資訊協作及整合應用
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span
                  >行政院農業委員會水土保持局 許炘志 助理程式設計師
                </div>
              </div>

              <div class="agenda-speaker-group">
                <div class="agenda-timeline-speaker">
                  Big Earth Datacubes: Seamless Integration and Enhanced Insight
                </div>
                <div class="agenda-host">
                  <span class="icon icon-user mr-1"></span>Jacobs University
                  Bremen Dr. Peter Baumann
                </div>
              </div>
            </div>

            <div class="agenda-timeline-group">
              <div class="agenda-timeline-time">17:00</div>
              <div class="agenda-timeline-content">賦歸</div>
            </div>
          </div>
        </div>
      </div>

      <b-overlay
        id="overlay-background"
        :show="overlay"
        :opacity="0.5"
        rounded="sm"
        :spinner-type="overlay_type"
      >
        <div id="fourthPage" class="section forum-signup">
          <div class="container">
            <h2>報名研討會</h2>
            <b-form class="signup">
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>姓名</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-input
                    placeholder="請輸入姓名"
                    v-model="SignData.name"
                    :state="CheckState(SignData.name, true)"
                  >
                  </b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>單位</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio name="govORsch" v-model="govORsch" value="0"
                    >政府部門</b-form-radio
                  >
                  <b-form-radio name="govORsch" v-model="govORsch" value="1"
                    >學術單位</b-form-radio
                  >
                  <b-form-radio name="govORsch" v-model="govORsch" value="2"
                    >公司行號</b-form-radio
                  >
                </b-col>
                <b-col sm="10" md="auto">
                  <b-row class="mb-1">
                    <b-form-input
                      v-model="SignData.position"
                      placeholder="請輸入單位名稱"
                      :state="CheckState(SignData.position, true)"
                    ></b-form-input>
                  </b-row>
                  <b-row>
                    <b-form-input
                      v-model="SignData.title"
                      placeholder="請輸入職稱"
                      :state="CheckState(SignData.title, true)"
                    ></b-form-input>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>性別</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio name="gender" v-model="SignData.sex" value="0"
                    >男</b-form-radio
                  >
                  <b-form-radio name="gender" v-model="SignData.sex" value="1"
                    >女</b-form-radio
                  >
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>手機號碼</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-input
                    placeholder="請輸入手機號碼"
                    v-model="SignData.phone"
                    :state="CheckState(SignData.phone, CheckPhone)"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="CheckPhone"
                    >請填寫正確的手機號碼格式
                    Ex:0912345678</b-form-invalid-feedback
                  >
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>電子信箱</label>
                </b-col>
                <b-col sm="10" md="auto" id="cmail">
                  <b-form-input
                    type="email"
                    placeholder="請輸入電子信箱"
                    v-model="SignData.email"
                    :state="CheckState(SignData.email, CheckMail)"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="CheckMail"
                    >請填寫正確的Email格式</b-form-invalid-feedback
                  >
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="2">
                  <label>飲食習慣 </label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio
                    name="eating"
                    v-model="SignData.eating"
                    value="0"
                    >葷</b-form-radio
                  >
                  <b-form-radio
                    name="eating"
                    v-model="SignData.eating"
                    value="1"
                    >素</b-form-radio
                  >
                </b-col>
              </b-row>

              <b-row class="mb-3">
                <b-col sm="2">
                  <label>有興趣了解</label>
                </b-col>
                <b-col sm="10" md="auto">
                  <b-form-radio
                    name="interest"
                    v-model="SignData.interest"
                    value="0"
                    >三維共構議題</b-form-radio
                  >
                  <b-form-radio
                    name="interest"
                    v-model="SignData.interest"
                    value="1"
                    >資料聯盟議題
                  </b-form-radio>
                  <b-form-radio
                    name="interest"
                    v-model="SignData.interest"
                    value="2"
                    >其他
                  </b-form-radio>
                  <b-form-radio
                    name="interest"
                    v-model="SignData.interest"
                    value="3"
                    >目前無興趣
                  </b-form-radio>
                </b-col>
                <b-col sm="10" md="auto" v-if="SignData.interest == '2'">
                  <b-row class="mb-1">
                    <b-form-input
                      v-model="SignData.interest_Another"
                      placeholder="請輸入詳細資訊"
                    ></b-form-input>
                  </b-row>
                </b-col>
              </b-row>

              <hr />
              <h5 style="display: block">
                個人資料蒐集、處理、利用告知暨同意書
              </h5>
              <hr />
              <div>個人資料蒐集、處理及利用同意書：</div>
              <div>
                本人同意國家高速網路與計算中心為推廣三維空間資訊基礎環境共構及資料聯盟，得將上開人個人資料提供予國家高速網路與計算中心暨其合作商基於行推廣之目的處理、利用。除前揭事項外，國家高速網路與計算中心非經本人書面同意或依法律規定，不得將本人上開個人資料提供予國家高速網路與計算中心及合作商以外之第三人進行行銷。經本人同意將上開個人資料提供予國家高速網路與計算中心及合作商後，若本人欲請求國家高速網路與計算中心及前述利用對象停止繼續為行銷利用，得透過國家高速網路與計算中心之服務管道請求停止處理、利用或刪除。如您提供的資料不完整或不確實，將無法完成本次報名作業。
              </div>
              <hr />
              <h5 style="display: block">
                2022三維空間資訊基礎環境共構及資料聯盟應用研討會防疫規範
              </h5>
              <hr />
              <div>
                本會議相關防疫規定遵照衛生福利部疾病管制署中央流行疫情指揮中心嚴重特殊傳染性肺炎最新規範
                <a
                  href="https://www.cdc.gov.tw/Category/List/4Xl0lLIeccvjFS1SeysBfQ"
                  >（前往連結）</a
                >
              </div>

              <hr />

              <b-row class="mb-3">
                <b-col sm="10" offset-md="2" md="auto">
                  <b-form-checkbox v-model="terms1"
                    >本人已確認上述填寫資料無誤</b-form-checkbox
                  >
                  <b-form-checkbox v-model="terms3"
                    >本人願意配合及遵守本研討會防疫規範。</b-form-checkbox
                  >
                  <b-form-checkbox v-model="terms2"
                    >本人已閱讀並了解上述之告知事項，並同意貴單位在符合上述告知事項範圍內蒐集、處理及利用本人個人資料。</b-form-checkbox
                  >
                  <b-form-checkbox v-model="terms4"
                    >本人願意接收國家高速網路與計算中心及行銷團隊之電子報資訊。</b-form-checkbox
                  >
                  <b-modal
                    id="modal-terms"
                    v-model="modal_terms_show"
                    title="報名失敗"
                    size="lg"
                    ok-only
                    ok-title="關閉"
                  >
                    <p>
                      請確認報名填寫資訊是否正確，並詳細閱讀個資同意書、防疫規範後勾選相關欄位，才能完成報名作業。
                    </p>
                  </b-modal>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="10" offset-md="2" md="auto">
                  <b-button
                    type="button"
                    variant="primary"
                    size="lg"
                    @click="CheckTerms"
                    >送出</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
            <b-modal
              id="modal-2"
              v-model="modal_2_show"
              title="報名完成"
              size="lg"
              ok-only
              ok-title="關閉"
              @ok="GoToPathHome"
            >
              <p>
                感謝您報名2022三維空間資訊基礎環境共構及資料聯盟應用研討會。
              </p>
              <p>確認信函已寄至：{{ SignData.email }}</p>
              <p>如未收到【確認信】，請至【垃圾郵件匣】查看。</p>
            </b-modal>
            <b-modal
              id="modal-timeOut"
              v-model="modal_timeOut_show"
              title="報名已截止"
              size="lg"
              ok-only
              ok-title="關閉"
            >
              <p>
                本研討會報名踴躍，因場地人數限制目前實體活動已截止報名，歡迎大家至Youtube「國研院國網中心」頻道線上觀看研討會，或點選<a
                  href="https://www.youtube.com/watch?v=_1GCVfLjg0Q"
                  >直播連結</a
                >。
              </p>
            </b-modal>
          </div>
        </div>
      </b-overlay>

      <!-- <div id="fifthPage" class="section forum-results">
          <div class="container">
            <h2>成果專區</h2>
          </div>
        </div> -->

      <div id="sixthPage" class="section forum-traffic">
        <div class="container">
          <h2>交通指南</h2>
          <div class="row mrt align-items-center">
            <div class="text-center col-auto">
              <img src="imgs/mrt.png" class="img-fluid" alt="" /><br />
              <strong>捷運</strong>
            </div>
            <div class="col align-self-stretch">
              <ul class="mb-0 list-unstyled">
                <li>
                  <span>搭乘捷運文湖線至「南京復興」站：</span
                  >由七號出口出站，步行約1分鐘左右即可抵達。
                </li>
                <li>
                  <span>搭乘捷運松山線至「南京復興」站：</span
                  >由六號出口出站，步行約1分鐘左右即可抵達。
                </li>
                <li>
                  <span
                    ><a
                      href="https://www.metro.taipei/cp.aspx?n=91974F2B13D997F1"
                      target="_blank"
                      >台北捷運路線資訊</a
                    ></span
                  >
                </li>
              </ul>
            </div>
          </div>

          <div class="row bus align-items-center">
            <div class="text-center col-auto">
              <img src="imgs/bus.png" class="img-fluid" alt="" /><br />
              <strong>公車</strong>
            </div>

            <div class="col">
              <ul class="mb-0 list-unstyled">
                <li>
                  <span>搭乘638、685、74、903公車：</span
                  >於「捷運南京復興」站下車。
                </li>
                <li>
                  <span
                    >搭乘248、254、266、266(區間)、
                    279、282、282(副)、288、288(區間)、292、292(副)、292(區間)、306、306(區間)、307、46、604、605(快速公車)、622、652、668、672、675、711、紅25、棕10、棕9
                    線：</span
                  >於「南京復興路口」站下車。
                </li>
              </ul>
            </div>
          </div>

          <div class="row car align-items-center">
            <div class="text-center col-auto">
              <img src="imgs/car.png" class="img-fluid" alt="" /><br />
              <strong>開車</strong>
            </div>

            <div class="col">
              <ul class="mb-0 list-unstyled">
                <li>
                  <span
                    ><a
                      href="https://goo.gl/maps/S1CpGxqfpHmdkQDYA"
                      target="_blank"
                      >規劃路線建議</a
                    ></span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <iframe
          src="https://ezsign.gis.tw/nchc2022event/map/Map.html"
          width="100%"
          height="450"
          frameborder="0"
          style="border: 0"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiGetOpen2,
  apiCheckRegister,
  apiGetAT_ID,
  apiNewRegister,
  apiGetKey,
  apiGetToken,
  apiGetMailToken,
  apiSendMail,
  apiSetLogRequest,
} from "../api/API";
export default {
  data() {
    return {
      State: true,
      RG_ID: null,
      terms1: false,
      terms2: false,
      terms3: false,
      terms4: false,
      govORsch: "0",
      SignData: {
        name: "",
        position: "",
        phone: "",
        sex: "0",
        email: "",
        eating: "0",
        interest: "0",
        interest_Another: "",
      },
      modal_terms_show: false,
      modal_2_show: false,
      modal_timeOut_show: false,
      overlay: false,
      overlay_type: "border",
    };
  },
  mounted() {
    this.CheckIsOpen();
  },
  methods: {
    async SendMail(id, count) {
      try {
        const token = (await apiGetMailToken()).data;
        var info = {
          id: id,
          mail: this.SignData.email,
          name: this.SignData.name,
          RG_ID: this.RG_ID,
          TokenID: "",
          Token: token,
          Page: "",
        };
        const sendMail = JSON.parse((await apiSendMail(info)).data);
        //console.log(sendMail);
        if (sendMail.Status) {
          this.overlay = false;
          this.modal_2_show = true;
        } else {
          if (count <= 5) {
            count++;
            this.SendMail(id, count);
          } else {
            const token = (await apiGetMailToken()).data;
            var lo = {
              Id: this.SignData.email,
              Message: "寄件失敗",
              TokenID: "",
              Token: token,
              Page: "",
            };
            const SetLog = JSON.parse((await apiSetLogRequest(lo)).data);
            console.error(SetLog);
            this.overlay = false;
            alert("寄件失敗，請聯絡相關人員 ");
          }
        }
      } catch (err) {
        if (count <= 5) {
          count++;
          this.SendMail(id, count);
        } else {
          const token = (await apiGetMailToken()).data;
          var logs = {
            Id: this.SignData.email,
            Message: err,
            TokenID: "",
            Token: token,
            Page: "",
          };
          const SetLog = JSON.parse((await apiSetLogRequest(logs)).data);
          console.error(SetLog);
          this.overlay = false;
          alert("寄件出現錯誤，請聯絡相關人員 ");
        }
      }
    },
    async Register() {
      try {
        this.overlay = true;
        const key = (await apiGetKey()).data[0]["Key"];
        //console.log(key);
        const token = (await apiGetToken(key)).data[0]["Token"];
        //console.log(token);
        const AT_ID = (await apiGetAT_ID(token)).data[0]["AT_ID"];
        //console.log(AT_ID);

        //CL20180307140909094
        var RegisterData = [
          //姓名
          { RD_CLID: "CL20190311182727127", RD_Value: this.SignData.name },
          //單位名稱
          { RD_CLID: "CL20180307140916893", RD_Value: this.SignData.position },
          //職稱
          { RD_CLID: "CL20220815144814548", RD_Value: this.SignData.title },
          //性別
          {
            RD_CLID: "CL20190311193313384",
            RD_Value:
              this.SignData.sex == "0"
                ? "CV20190311193344352"
                : "CV20190311193335665",
          },
          //手機號碼
          {
            RD_CLID: "CL20180314141037348",
            RD_Value: this.SignData.phone,
          },
        ];
        //單位
        var gscVal = "";
        if (this.govORsch == "0") {
          gscVal = "CV20201022102804909";
        }
        if (this.govORsch == "1") {
          gscVal = "CV20201022102816730";
        }
        if (this.govORsch == "2") {
          gscVal = "CV20201016141128829";
        }
        RegisterData.push({ RD_CLID: "CL20201006102625094", RD_Value: gscVal });
        //飲食需求(單選)
        if (this.SignData.eating == "0") {
          RegisterData.push({ RD_CLID: "CL20180307141103300", RD_Value: 'CV20180307141116883' });
        } else {
          RegisterData.push({ RD_CLID: "CL20180307141103300", RD_Value: 'CV20180323140015686' });
        }
        //有興趣了解
        let interestID = null;
        if (this.SignData.interest == "0") {
          interestID = 'CV20220808145603101';
        } else if (this.SignData.interest == "1") {
          interestID = 'CV20220808145611594';
        } else if (this.SignData.interest == "2") {
          interestID = 'CV20220808145618356';
          RegisterData.push({ RD_CLID: "CL20220808145630907", RD_Value: this.SignData.interest_Another });
        } else if (this.SignData.interest == "3") {
          interestID = 'CV20220815155203505';
        }
        RegisterData.push({ RD_CLID: "CL20220808145519425", RD_Value: interestID });
        //願意接收易學堂最新活動及推廣資訊
        if (this.terms4) {
          RegisterData.push({ RD_CLID: "CL20220815144612942", RD_Value: 'CV20220815144716092' });
        } else {
          RegisterData.push({ RD_CLID: "CL20220815144612942", RD_Value: 'CV20220815144722151' });
        }

        var Register = {
          RG_ATID: AT_ID,
          RG_Email: this.SignData.email,
          RG_CName: this.SignData.name,
          RG_LName: "",
          RG_FName: "",
          VolumnData: RegisterData,
        };
        console.log(Register);

        const NewRegister = await apiNewRegister(token, Register);
        //console.log(NewRegister.data["Result"]);
        this.RG_ID = NewRegister.data["Result"];

        if (
          NewRegister.data["Result"] ==
          "該活動尚未開啟報名(This activity is not open yet.)"
        ) {
          this.modal_timeOut_show = true;
        } else {
          const isRegister = (await apiCheckRegister(this.SignData.email))
            .data[0]["IsRegister"];
          console.log(isRegister)
          if (isRegister == "true") {
            this.SendMail(NewRegister.data["Result"], 1);
          } else {
            this.overlay = false;
            alert("報名失敗");
          }
        }
      } catch (err) {
        console.error(err);
        alert("註冊出現錯誤，請聯絡相關人員");
      }
    },
    async CheckRegister() {
      try {
        const isRegister = (await apiCheckRegister(this.SignData.email))
          .data[0]["IsRegister"];
        if (isRegister == "false") {
          this.Register();
        } else {
          alert("此Emial已有報名過");
        }
      } catch (err) {
        console.error(err);
        alert("檢查出現錯誤，請聯絡相關人員");
      }
    },
    CheckState(val, CMail) {
      if ((val == "" || !CMail) && !this.State) return false;
      else return null;
    },
    CheckData() {
      if (
        this.SignData.name == "" ||
        this.SignData.email == "" ||
        this.SignData.position == "" ||
        this.SignData.title == ""
      ) {
        this.State = false;
        alert("請填入必填資料");
      } else if (
        this.SignData.interest == "2"
      ) {
        if (this.SignData.interest_Another == "") {
          alert('請填寫有興趣了解之詳細資訊')
        } else {
          this.CheckRegister();
        }
      } else {
        this.CheckRegister();
        // alert("註冊");
      }
    },
    CheckTerms() {
      if (
        this.terms1 == false ||
        this.terms2 == false ||
        this.terms3 == false ||
        this.SignData.position == null ||
        this.SignData.title == null
      ) {
        this.modal_terms_show = true;
      } else {
        this.CheckData();
      }
    },
    async CheckIsOpen() {
      const key = (await apiGetKey()).data[0]["Key"];
      const token = (await apiGetToken(key)).data[0]["Token"];
      const AT_ID = (await apiGetAT_ID(token)).data[0]["AT_ID"];
      const isOpen = (await apiGetOpen2(token, AT_ID)).data[0]["IsOpen"];
      console.log(isOpen)
      if (isOpen != "true") {
        this.modal_timeOut_show = true;
        this.overlay_type = "";
        this.overlay = true;
      }
    },
  },
  computed: {
    CheckMail() {
      const mailRegExp = new RegExp(
        "^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$"
      );
      return mailRegExp.test(this.SignData.email);
    },
    CheckidNum() {
      const idRegExp = new RegExp(
        "^[A-Za-z]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+$"
      );
      return idRegExp.test(this.SignData.idNum);
    },
    CheckPhone() {
      var MobileReg = /^(09)[0-9]{8}$/;
      return this.SignData.phone.match(MobileReg) ? true : false;
    },
  },
};
</script>